import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import FormList from '../../../basicElement/FormList';
import { getMatchOption } from '../../../shared/selectFn';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';
import ExportUtil from '../../../../common/ExportUtil';

let Constants = {};
const getStatusByType = (type) => {
    switch(type) {
        case 'add':
            return {
                add: true,
                title: '添加合同信息变更申请',
                saveUrl: API_URL.contract.createInvestigationJdeContractModifyApply,
            };
        case 'edit':
            return {
                edit: true,
                title: '修改合同信息变更申请',
                saveUrl: API_URL.contract.modifyInvestigationJdeContractModifyApply,
            }
    }
};

// 变更字段
const ChangeFieldList = [
    { label: '计收入确认方式', value: 'contractType', flag: true },
    { label: '客户全名', value: 'customerCompany', flag: false },
    { label: '执行业务线二级分类', value: 'secondLine', flag: false },
    { label: '名称(ProjectID)', value: 'projectId', flag: false },
    { label: '合同附件', value: 'contractFile', flag: false },
];
let ChangeFieldOption = [];
const getChangeFieldOptionByRole = (flag) => ChangeFieldList.filter(i => i.flag == flag);

const initialAfterChangeValue = {
    oldId: undefined,
    oldValue: undefined,
    contractTypeValue : undefined,
    customerCompanyId : undefined,
    customerCompanyName : undefined,
    baUserId : undefined,
    baUserId : undefined,
    secondLineIds : [],
    files : [],
    projectIdName : undefined,
};

class Update extends Component {
    state = {
        loading: false,
        visible: false,
        relationContractList: [],
        contractTypeList: [],
        fileList: [],
        newFileList:[],
        data: {},
    }

    dictLoaded = false

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb);
        }, res => {
            this.dictLoaded = true;
            this.setState({ contractTypeList: res.contractTypeList || [] });
        });
    }

    show = (params, type) => {
        // 计收入确认方式字典与项目数据无关，首开一次；请求失败则下次打开自动重试
        if (!this.dictLoaded) {
            this.loadTypeConfigureList();
        }
        const { invId, invName, curRole, userId } = sessionStorage;
        const { fieldType, newId, baUserName, baUserCode, pmUserIds, lineOfBusinessString,newList ,newValue ,oldValue } = params;
        if (fieldType === 'secondLine') {
            if (lineOfBusinessString === 'ARO') {
                params.newId = newId ? newId.split(',') : [];
            } else {
                params.newId = newId ? (newId + '').replace(/(,\d+)+$/g, '') : undefined;
                params.oldValue = oldValue || undefined;
                params.newValue = newValue || undefined;
            }
        } else if (fieldType === 'customerCompany') {
            params.baUserName = `${baUserName}[${baUserCode}]`;
        }
        Constants = getStatusByType(type);
        const otherRoleEdit = (pmUserIds || '').split(',').includes(userId);
        const flag = (curRole === 'CRC' || curRole === 'CRCM' || curRole === 'CRCC' || curRole === 'PM' || curRole === 'PML' || curRole === 'BO' || otherRoleEdit);
        ChangeFieldOption = getChangeFieldOptionByRole(flag);
        const [{ value: defaultFieldType } = {}] = ChangeFieldOption;
        const newFileList = newList?[...newList]:[];
        newFileList.forEach(item=>{
            item.response = { fileMetaId: item.fileMetaId };
            item.uid = item.fileMetaId;
            item.name = item.fileName;
        })
        this.setState({
            data: {
                fieldType: defaultFieldType,
                investigationId: invId || undefined,
                investigationName: invName || undefined,
                ...params,
                newFileList
            },
            visible: true,
        }, () => {
            this.loadRelationContractList();
            if (Constants.edit) {
                this.loadedFileList(
                    this.loadContractFileList(),
                    this.loadCurrentFileList()
                );
            }else if(Constants.add){
                this.loadedFileList(
                    this.loadContractFileList(),
                );
            }
        });
    }

    hide = () => {
        this.setState({
            fileList: [],
            visible: false,
        });
    }
    // 下载文件
    download = (params) => {
        ExportUtil.export(params, null, API_URL.contract.downloadJdeCodeEnclosure);
        message.success('正在下载中!')
    }

    // 处理合同附件、当前附件
    loadedFileList = (...promises) => {
        Promise.all(promises).then(res => {
            const { data } = this.state;
            // 兼容360
            const flat = [].flat ? [].flat : [].flatten;
            data.fileList = flat.call(res || []);
            this.setState({ data });
        }).catch(error => {
            console.error(error);
        })
    }

    loadContractFileList = () => {
        const { data: { investigationJdeContractId,fieldType } } = this.state;
        if (investigationJdeContractId && fieldType !== 'contractFile') {
            return Fetch.post(API_URL.contract.queryJdeCodeEnclosure, {
                investigationJdeContractId,
            }).then(res => {
                const fileList = res.data || [];
                fileList.forEach((item, index) => {
                    item.response = { fileMetaId: item.id };
                    item.uid = item.id;
                    item.deletable = false;
                });
                return fileList;
            });
        } else {
            return Promise.resolve([]);
        }
    }

    loadCurrentFileList = () => {
        const { data: { investigationJdeContractModifyApplyId } } = this.state;
        return Fetch.post(API_URL.contract.queryEnclosureFileByType, {
            relatedId: investigationJdeContractModifyApplyId,
            fileType: 'CONTRACT_MODIFY',
        }).then(res => {
            const fileList = res.data || [];
            fileList.forEach((item, index) => {
                item.response = { fileMetaId: item.fileMateId };
                item.uid = item.fileMateId;
            });
            return fileList;
        });
    }

    /**
     * 查询JDE
     */
    loadRelationContractList = () => {
        const { data: { investigationId } } = this.state;
        if (investigationId) {
            Fetch.post(API_URL.contract.selectContractForAddRemittance, { investigationId, isModify: 0 , contractModify: 1})
                .then(res => {
                    this.setState({ relationContractList: res.data || [] });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ relationContractList: [] });
        }
    }

    handleChange = (value, key, type) => {
        const { businessList } = this.props;
        const { data, contractTypeList, relationContractList } = this.state;
        switch (key) {
            case 'investigationName': {
                const { value: id, text: name } = value;
                data.investigationId = id;
                data.investigationName = name;
                this.setState({ data }, () => {
                    this.handleChange(undefined, 'investigationJdeContractId');
                    this.loadRelationContractList();
                });
                break;
            }
            case 'investigationJdeContractId':
            case 'fieldType': {
                const newData = {
                    ...data,
                    ...initialAfterChangeValue,
                    [key]: value,
                };
                const { fieldType, investigationJdeContractId } = newData;
                const {
                    contractTypeId, contractTypeValue, customerCompanyId, customerCompanyName,
                    lineOfBusiness, secondLineIds, secondLineNames, projectIdName,files
                } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
                const { groupId } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
                if (fieldType === 'contractType') {
                    newData.oldId = contractTypeId;
                    newData.oldValue = contractTypeValue;
                } else if (fieldType === 'customerCompany') {
                    newData.oldId = customerCompanyId;
                    newData.oldValue = customerCompanyName;
                } else if (fieldType === 'secondLine') {
                    newData.oldId = secondLineIds;
                    newData.oldValue = secondLineNames;
                } else if (fieldType === 'projectId') {
                    newData.oldId = undefined;
                    newData.oldValue = projectIdName;
                }
                else if (fieldType === 'contractFile') {
                    newData.oldId = [];
                    newData.oldList = files?files.map((file)=>{
                        return ({fileMetaId:file.id,fileName:file.name})
                    }):'';
                }
                if (fieldType === 'secondLine' && groupId === 2) {
                    newData.newId = [];
                } else {
                    newData.newId = undefined;
                }
                newData.newValue = undefined;
                data.baUserId = undefined;
                data.baUserName = undefined;
                this.setState({ data: newData }, () => {
                    if (key === 'investigationJdeContractId') {
                        this.loadedFileList(this.loadContractFileList());
                    }
                    if(fieldType !== 'contractFile'){
                        this.loadedFileList(this.loadContractFileList());
                    }
                });
                break;
            }
            case 'newId':
            case 'newValue': {
                const { fieldType } = data;
                if (fieldType === 'contractType') {
                    const { typeValue } = getMatchOption(contractTypeList, 'typeConfigureId', value);
                    data.newId = value;
                    data.newValue = typeValue;
                } else if (fieldType === 'customerCompany') {
                    const { value: id, text: name } = value;
                    data.newId = id;
                    data.newValue = name;
                } else if (fieldType === 'secondLine') {
                    const { investigationJdeContractId } = data;
                    const { lineOfBusiness } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
                    const { childList: secondLineList, groupId } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
                    let names;
                    if (groupId === 2) {
                        names = (value || []).map(id => getMatchOption(secondLineList, 'typeConfigureId', id).typeValue).join(',')
                    } else {
                        names = getMatchOption(secondLineList, 'typeConfigureId', value).typeValue
                    }
                    data.newId = value;
                    data.newValue = names;
                    console.log(value,names);
                } else if (fieldType === 'projectId') {
                    data.newId = undefined;
                    data.newValue = value;
                } else {
                    data.newId = undefined;
                    data.newValue = undefined;
                }
                data.baUserId = undefined;
                data.baUserName = undefined;
                this.setState({ data });
                break;
            }
            case 'baUserName': {
                const { value: id, text: name } = value;
                data.baUserId = id;
                data.baUserName = name;
                this.setState({ data });
                break;
            }
            default: {
                data[key] = value;
                this.setState({ data });
                break;
            }
        }
    }

    getColumns = () => {
        const { invState } = sessionStorage;
        const { businessList } = this.props;
        const { data, relationContractList, contractTypeList } = this.state;
        const { investigationId, investigationJdeContractId, fieldType,newList,newFileList } = data;
        const relationContractOption = relationContractList.map(i => ({ label: i.investigationJdeContractCode, value: i.investigationJdeContractId}));
        // 字段属性配置
        const columns = [];
        if (invState == 0) {
            columns.push({
                name: '项目简称',
                key: 'investigationName',
                type: 'searchRetrieve',
                typeProperty:{
                    keyword: 'investigationName',
                    style: {width: 240},
                    placeholder: '输入名称检索',
                    // params: {limit: 20,noFinished:true,isPmInv:'TRUE'},
                    params: {limit: 20,noFinished:true},
                    url: API_URL.investigation.queryInvestigationByName,
                    config: { id: 'investigationId', name: 'investigationName' }
                },
                rules:{
                    required: true,
                }
            })
        }
        columns.push({
            name: 'JDE项目号',
            key: 'investigationJdeContractId',
            type: 'select',
            typeProperty: {
                style: {width: 240},
                list: relationContractOption,
                disabled: !investigationId
            },
            rules: {
                required: true,
            }
        }, {
            name: '变更字段',
            key: 'fieldType',
            type: 'select',
            typeProperty: {
                style: {width: 240},
                list: ChangeFieldOption,
            },
            rules: {
                required: true,
            },
            suffix: fieldType === 'secondLine' && <p style={{ marginTop: 8, color: '#F00' }}>合同的执行业务线二级分类变更后，将批量变更本项目下所有合同的“执行业务线二级分类”，请谨慎操作</p>
        });
        if(fieldType == 'contractFile'){
            columns.push(
                {
                    name: '变更前',
                    key: 'oldList',
                    type: 'textList',
                }
            )
        }else {
            columns.push(
                {
                    name: '变更前',
                    key: 'oldValue',
                    type: 'text',
                }
            )
        }
        // 根据合同、变更字段设置变更后字段
        if (fieldType === 'contractType') {
            const contractTypeOption = contractTypeList.map(i => ({ label: i.typeValue, value: i.typeConfigureId }));
            columns.push({
                name: '变更后',
                key: 'newId',
                type: 'select',
                typeProperty: {
                    list: contractTypeOption,
                    style: {width: 240},
                    disabled: !investigationJdeContractId
                },
                rules: {
                    required: true,
                }
            });
        } else if (fieldType === 'customerCompany') {
            columns.push({
                name: '变更后',
                key: 'newValue',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'customerCompanyName',
                    style: {width: 240},
                    placeholder: '输入客户名称检索',
                    params: {limit: 20},
                    disabled: !investigationJdeContractId,
                    url: API_URL.investigation.queryCustomerCompanyByName,
                    config: { id: 'customerCompanyId', name: 'customerCompanyName' }
                },
                rules: {
                    required: true,
                }
            }, {
                name: 'BA',
                key: 'baUserName',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'keyWord',
                    style: {width: 240},
                    placeholder: '输入姓名/工号检索',
                    params: {limit: 20, roleCodes: 'BA,BAL'},
                    url: API_URL.teaching.queryEmpListByRoleCode,
                    config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
                },
                rules: {
                    required: true,
                }
            });
        } else if (fieldType === 'secondLine') {
            const { lineOfBusiness } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
            const { childList: secondLineList, groupId } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
            const secondLineOption = (secondLineList || []).map(i => ({ label: i.typeValue, value: i.typeConfigureId }));
            const settings = {};
            if (groupId === 2) {
                settings.mode = 'multiple';
            }
            columns.push({
                name: '变更后',
                key: 'newId',
                type: 'select',
                typeProperty: {
                    ...settings,
                    list: secondLineOption,
                    style: {width: 240},
                    disabled: !investigationJdeContractId || !data.oldValue
                },
                rules: {
                    required: true,
                }
            });
        } else if (fieldType === 'projectId') {
            columns.push({
                name: '变更后',
                key: 'newValue',
                type: 'input',
                typeProperty: {
                    style: {width: 240},
                    disabled: !investigationJdeContractId
                },
                rules: {
                    required: true,
                }
            });
        }else if(fieldType === 'contractFile'){
            columns.push({
                name: '变更后',
                key: 'newFileList',
                type: 'upload',
                typeProperty: {
                    params: {
                        uploadType: 'CONTRACT_MODIFY',
                        path: Date.now(),
                        relateId: '',
                    },
                    uploadUrl: API_URL.proContract.uploadJdeCodeEnclosure,
                    removeUrl: API_URL.proContract.deleteJdeCodeEnclosure,
                },
                rules: {
                    required: true,
                }
            });
        } else {
            columns.push({
                name: '变更后',
                key: 'newValue',
                type: 'text',
                rules: {
                    required: true,
                }
            });
        }
        columns.push({
            name: '变更原因',
            key: 'reason',
            type: 'input',
            typeProperty: {
                style: { width: 300 },
            },
            rules: {
                required: true,
            }
        }) 
        if(fieldType !== 'contractFile'){
            columns.push({
                name: '附件',
                key: 'fileList',
                type: 'upload',
                typeProperty: {
                    params: {
                        uploadType: 'CONTRACT_MODIFY',
                        path: Date.now(),
                        relateId: '',
                    },
                    uploadUrl: API_URL.proContract.uploadJdeCodeEnclosure,
                    removeUrl: API_URL.proContract.deleteJdeCodeEnclosure,
                },
                rules: {
                    required: true,
                }
            });
        }
        

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = true;
                if (type === 'upload') {
                    typeProperty.value = data[key] || [];
                } else {
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const  { curRole } = sessionStorage;
        const { data } = this.state;
        const { newId,newFileList, fileList,fieldType, ...otherData } = data;
        const files = {};
        let index = 0;
        let newInsex = 0;
        (fileList || []).forEach((item) => {
            if (item.deletable !== false) {
                files[`ids[${index++}]`] = item.response.fileMetaId;
            }
        });
        (newFileList || []).forEach((item) => {
            if (item.deletable !== false) {
                files[`ids[${newInsex++}]`] = item.response.fileMetaId;
            }
        });
        if (index === 0 && fieldType !=='contractFile') {
            message.warning('请上传变更附件！');
            return;
        }else if(newInsex === 0 && fieldType =='contractFile'){
            message.warning('请上传变更后附件！');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(Constants.saveUrl, {
            ...otherData,
            ...files,
            fieldType,
            newId: Array.isArray(newId) ? newId.join(',') : newId,
            roleCode: curRole,
        }).then(res => {
            message.success(res.success);
            this.setState({
                visible: false,
                loading: false,
            }, () => {
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={Constants.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <FormList
                            className="form-list"
                            columns={this.getColumns()}
                            onChange={this.handleChange}
                            ref={el => this.formRef = el}
                        />
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractInfoChange/components/Update.js